import { CognitoUserPool, ICognitoUserPoolData } from 'amazon-cognito-identity-js'

const poolData: ICognitoUserPoolData = {
  UserPoolId: process.env.REACT_APP_USER_POOL_ID ?? '',
  ClientId: process.env.REACT_APP_CLIENT_ID ?? ''
}

const userPoolRegion = process.env.REACT_APP_REGION
const userPool = new CognitoUserPool(poolData)

export {
  userPool,
  userPoolRegion
}
